import React from "react"
import ForHealthCoachKeyFeaturesStyle from "./ForHealthCoachKeyFeaturesStyle.module.styl"
import Image from "gatsby-image"
import translate from "../../../../../translation/translator"
import keys from "../../../../../translation/keys"

const ForHealthCoachKeyFeatures = ({ images, locale }) => {
  const image1 = images[0].node.childImageSharp.fluid
  const image2 = images[1].node.childImageSharp.fluid
  const image3 = images[2].node.childImageSharp.fluid
  const image4 = images[3].node.childImageSharp.fluid
  return (
    <div className={ForHealthCoachKeyFeaturesStyle.wrapper}>
      <h2 className={ForHealthCoachKeyFeaturesStyle.section_title}>
        {translate(keys.HLTH_COACH_KEY_FEATURES_KEY_FEATURES, locale)}
      </h2>
      <div className={ForHealthCoachKeyFeaturesStyle.items_holder}>
        <div className={ForHealthCoachKeyFeaturesStyle.holder}>
          <div className={ForHealthCoachKeyFeaturesStyle.image_holder}>
            <Image alt="health-coach-feature" fluid={image1} />
          </div>
          <div className={ForHealthCoachKeyFeaturesStyle.description}>
            <p>
              {translate(keys.HLTH_COACH_KEY_FEATURES_ONLINE_CALENDAR, locale)}
            </p>
            <p>{translate(keys.HLTH_COACH_KEY_FEATURES_CAL_TEXT, locale)}</p>
          </div>
        </div>
        <div className={ForHealthCoachKeyFeaturesStyle.holder_margin}>
          <div className={ForHealthCoachKeyFeaturesStyle.image_holder}>
            <Image alt="health-coach-feature" fluid={image2} />
          </div>
          <div className={ForHealthCoachKeyFeaturesStyle.description}>
            <p>
              {translate(keys.HLTH_COACH_KEY_FEATURES_INOVATION_TEXT, locale)}
            </p>
            <p>
              {translate(keys.HLTH_COACH_KEY_FEATURES_WORK_FROM_HOME, locale)}
            </p>
          </div>
        </div>
      </div>
      <div className={ForHealthCoachKeyFeaturesStyle.items_holder}>
        <div className={ForHealthCoachKeyFeaturesStyle.holder}>
          <div className={ForHealthCoachKeyFeaturesStyle.image_holder}>
            <Image alt="health-coach-feature" fluid={image3} />
          </div>
          <div className={ForHealthCoachKeyFeaturesStyle.description}>
            <p>{translate(keys.HLTH_COACH_KEY_FEATURES_YOU_ARE, locale)}</p>
            <p>
              {translate(keys.HLTH_COACH_KEY_FEATURES_YOU_ARE_TEXT, locale)}
            </p>
          </div>
        </div>
        <div className={ForHealthCoachKeyFeaturesStyle.holder_margin}>
          <div className={ForHealthCoachKeyFeaturesStyle.image_holder}>
            <Image alt="health-coach-feature" fluid={image4} />
          </div>
          <div className={ForHealthCoachKeyFeaturesStyle.description}>
            <p>
              {translate(
                keys.HLTH_COACH_KEY_FEATURES_FOLLOW_INOVATIONS,
                locale
              )}
            </p>
            <p>
              {translate(keys.HLTH_COACH_KEY_FEATURES_INOVATION_TEXT, locale)}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ForHealthCoachKeyFeatures
